<template>
    <div class="text-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_image.png" alt="">
                        </div>

                        <h4>Image URL <span class="text--error" v-if="!validData">(Invalid Card Data)</span></h4>

                    </div>
                </template>
                <div class="block-card-body" v-if="validData">
                    <label >URL</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.url"-->
<!--                            :error="!data.url || !common.validURL(data.url)"-->
<!--                            :error-messages="!data.url? 'URL is Required':'' || !common.validURL(data.url)? 'URL is not valid':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.url" :type="'textfield'"
                                           :validationRules="autocompleteImageUrlValidationrRules"></vTextareaAutocomplete>
                </div>
                <slot name = "tail" />
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    import FormValidation from '../FormValidation'
    export default {
        name: "card-image-url",
        components: {
    FormValidation
  },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
          validData: {
            type: Boolean,
            default: ()=> {
              return false
            }
          }
        },
        data() {
            return {
                errorsCount: { errorsCount: 0 },
      lazyRendering: true,
                valid: true,
                panel: 1,
                common,
                autocompleteImageUrlValidationrRules: [
                    v => !!v || "Image url is required"
                ]
            }
        },
        mounted() {
if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
        },
        methods: {

        },
        computed: {

        },
        watch: {
errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    },
        }
    }
</script>

<style scoped>

</style>
